const findCheapestShipmentInfo = info => {
  let cheapestCarrier;
  if (!info.shipmentInfoByType) return undefined;
  Object.values(info.shipmentInfoByType).forEach(shipmentInfo => {
    if (!cheapestCarrier) {
      cheapestCarrier = shipmentInfo;
      return;
    }

    if (shipmentInfo.shipmentCost < cheapestCarrier.shipmentCost) {
      cheapestCarrier = shipmentInfo;
    }
  });
  return cheapestCarrier;
};

export { findCheapestShipmentInfo };
